import React, { FC } from 'react';

import { RowData } from '../organisms/NumericKeyPad';
export interface GroupKeyboardProps {
    data: RowData[];
    onClick?: (e: RowData) => void;
}
const GroupKeyboard: FC<GroupKeyboardProps> = ({ onClick, data }) => (
    <div className = { 'm-group-keyboard' }>
        {
            data.map(item => (
                <button
                    className = { 'm-group-keyboard-button' }
                    onClick = { () => onClick(item.number) }
                    style = {{ padding: 0 }}>
                    <b>{item.number}</b>
                    <span className = 'm-group-keyboard-button-pad'>{item.pad}</span>
                </button>
            ))
        }
    </div>
);

GroupKeyboard.defaultProps = {
    data: [],
    onClick: () => { }
};
export default GroupKeyboard;
